/**
 * Literais das políticas de acesso (`/access-policies`, faixa 28 — back `app/permissions/permissions.py::SecurityPermissions`).
 * FORA de todo preset: só o dstorres até alguém conceder em runtime. Const porque o contract test (`literals.test.ts`)
 * só alcança CONSTS e `check.ts` faz `includes()` exato: literal errado é fail-closed e mudo.
 */
export const SECURITY_PERMISSIONS = {
  /** GET registry/tenant/sub-roles/users (+ `/effective`). Sem ela a seção/aba some — o GET seria 403. */
  POLICIES_READ: 'security:policies:read',
  /** PATCH tenant/sub-roles/users. Sem ela as três telas ficam só leitura. */
  POLICIES_UPDATE: 'security:policies:update',
} as const
